// Hotjar consent-gated dynamic injection. Mirrors metaPixelTag.js.
// Hotjar only loads after the user grants analytics consent.
//
// Set VITE_HOTJAR_SITE_ID in env. 0 / invalid / empty = disabled.
const rawHotjarSiteId = import.meta?.env?.VITE_HOTJAR_SITE_ID || '';
export const HOTJAR_SITE_ID = Number.parseInt(rawHotjarSiteId, 10) || 0;
const HOTJAR_VERSION = 6;

const configuredHosts = [];
const appUrl = import.meta?.env?.VITE_APP_URL;
if (typeof appUrl === 'string') {
  try {
    configuredHosts.push(new URL(appUrl).hostname);
  } catch {
    configuredHosts.push(appUrl);
  }
}
const HOTJAR_HOSTS = new Set([
  ...configuredHosts,
  'adulab.app',
  'www.adulab.app',
  'adu-lab-uat.web.app',
]);
const LOADED_FLAG = '__hotjar_loaded';

function isAllowedHost() {
  try {
    return HOTJAR_HOSTS.has(window.location.hostname);
  } catch {
    return false;
  }
}

export function loadHotjar() {
  if (!isAllowedHost()) return;
  if (!HOTJAR_SITE_ID) return;
  if (window[LOADED_FLAG]) return;
  window[LOADED_FLAG] = true;

  window.hj = window.hj || function () {
    // eslint-disable-next-line prefer-rest-params
    window.hj.q = window.hj.q || [];
    window.hj.q.push(arguments);
  };
  window._hjSettings = {
    hjid: HOTJAR_SITE_ID,
    hjsv: HOTJAR_VERSION,
  };

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://static.hotjar.com/c/hotjar-${HOTJAR_SITE_ID}.js?sv=${HOTJAR_VERSION}`;
  s.setAttribute('data-cmp', 'hotjar');
  document.head.appendChild(s);
}

export function cleanupHotjar() {
  window[LOADED_FLAG] = false;
  window.hj = undefined;
  window._hjSettings = undefined;

  const expired = `; expires=${new Date(0).toUTCString()}; path=/`;
  const host = window.location.hostname;
  ['_hjSessionUser', '_hjSession', '_hjFirstSeen', '_hjIncludedInSessionSample'].forEach((name) => {
    document.cookie = `${name}=;${expired}; domain=${host}`;
    document.cookie = `${name}=;${expired}`;
    if (!host.startsWith('.')) {
      document.cookie = `${name}=;${expired}; domain=.${host}`;
    }
  });

  document.querySelectorAll('script[data-cmp="hotjar"]').forEach((el) => el.remove());
}
